import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { GlobalCfgService } from "./globalcfg.service";
import { environment } from "../environments/environment";

@Injectable()
export class UserService {
  constructor(
    private http: HttpClient,
    private globalCfgService: GlobalCfgService
  ) {}

  getUserDetail(userId) {
    return this.http.get(
      environment.apiurl +
        "/RMUsers/" +
        userId +
        "?access_token=" +
        this.globalCfgService.getAccessToken()
    );
  }

  updateUserPhoto(id, val) {
    return this.http.patch(
      environment.apiurl +
        "/RMUsers/" +
        id +
        "?access_token=" +
        this.globalCfgService.getAccessToken(),
      {
        photoUrl: val
      }
    );
  }

  getUserContact(gcp) {
    var filter = JSON.stringify({
      where: {
        gcp: gcp
      }
    });
    return this.http.get(
      environment.apiurl +
        "/Contacts/?filter=" +
        filter +
        "&access_token=" +
        this.globalCfgService.getAccessToken()
    );
  }

  getFcmkeyUserDetails(userId) {
    return this.http.get(environment.apiurl +
      "/UserLoginDetails?filter="  + JSON.stringify({
        where: {
          userId:userId

        }
      }
      )+
      "&access_token=" +
        this.globalCfgService.getAccessToken()
    )
  }

  createContact(rec) {
    return this.http.post(environment.apiurl + "/Contacts?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }

  updateContact(rec) {
    return this.http.put(environment.apiurl + "/Contacts?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }

  getLocation(url) {
    return this.http.get(url);
  }

  changePwd(rec) {
    return this.http.post(
      environment.apiurl +
        "/RMUsers/change-password?access_token=" +
        this.globalCfgService.getAccessToken(),
      rec
    );
  }

  getUsers(gcp, page?) {
    var filter = {
      order: 'firstName ASC',
      limit: page && page.pageSize ? page.pageSize : 5,
      skip: page && page.pageSize ? page.pageSize * page.pageIndex : 0
    };
    if (gcp) {
      filter['where'] = {
        gcp: gcp
      }
    }
    return this.http.get(environment.apiurl + "/RMUsers?access_token=" + this.globalCfgService.getAccessToken() + "&filter=" + JSON.stringify(filter));
  }

  addUser(rec) {
    return this.http.post(environment.apiurl + "/RMUsers?access_token=" + this.globalCfgService.getAccessToken(),  rec);
  }

  updateUser(id, rec) {
    return this.http.patch(environment.apiurl + "/RMUsers/" + id + "?access_token=" + this.globalCfgService.getAccessToken(),  rec);
  }

  removeUser(id) {
    return this.http.delete(environment.apiurl + "/RMUsers/" + id + "?access_token=" + this.globalCfgService.getAccessToken());
  }

  changeUserStatus(id, isActive) {
    return this.http.patch(environment.apiurl + "/RMUsers/" + id + "?access_token=" + this.globalCfgService.getAccessToken(),  {
      isActive: isActive
    });
  }

  itemsOwnedByUser(dappUserId, page?) {
    // var filter = {
    //   limit: page && page.pageSize ? page.pageSize : 5,
    //   skip: page && page.pageSize ? page.pageSize * page.pageIndex : 0
    // };
    return this.http.get(environment.apiurl + "/RMUsers/instanceOwnByUser?access_token=" + this.globalCfgService.getAccessToken() + "&dappUserId=" + dappUserId);
  }
}
